'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './dashboard.routes';

export class DashboardComponent {
  /*@ngInject*/
  constructor(FB, $firebaseAuth, baseConfigService, $state, $cookies, $scope,
    $stateParams, $rootScope, userService, navService, fetch, lookup, $timeout) {
    'ngInject';

    const vm = this;

    this.$state = $state;
    this.$cookies = $cookies;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$stateParams = $stateParams;
    this.$rootScope = $rootScope;

    this.navService = navService; 
    this.fetch = fetch 
    this.lookup = lookup 
    this.userService = userService;
    this.baseConfigService = baseConfigService;
    $scope.baseUrl = baseConfigService.getBaseURL();

    this.$scope.stationAreas = [];

    this.excludedPolicies = [
    'Commercial Office Uses Data Verification',
    'Residential Uses Data Verification'
  ];

    $scope.recalculateCategoryTotals = function() {
      $scope.totalScore_density = _.sumBy($scope.densitySubmissions, (o) => Number(o.score) || 0);
      $scope.totalScore_housing = _.sumBy($scope.housingPolicySubmissions, (o) => Number(o.score) || 0);
      $scope.totalScore_parking = _.sumBy($scope.parkingSubmissions, (o) => Number(o.score) || 0);
      $scope.totalScore_stationAccess = _.sumBy($scope.stationAccessSubmissions, (o) => Number(o.score) || 0);
    };

$scope.validateScore = function(item) {
  if (item.score < 0) {
    item.score = 0;
  }
  if (item.score > item.max_score) {
    item.score = item.max_score;
    console.warn('Score cannot exceed ' + item.max_score);
  }
  $scope.recalculateCategoryTotals();
};

$scope.updateScore = function (item) {
    if (item.excludeFromScoring || !item.submitted_date) {
      console.log('Skipping update - excluded or no submission');
      return;
    }
    if (!$scope.currentUser || !$scope.currentUser.firstname || !$scope.currentUser.lastname) {
      console.error('Current user not available');
      return;
    }
    
    var scoreData = {
      submission_id: item.submission_id,
      score: parseInt(item.score) || 0,
      score_last_updated_by: `${$scope.currentUser.firstname} ${$scope.currentUser.lastname}`
    };

    fetch.updateItem('api/data/submissions/update-score', scoreData)
  .then(response => {
    vm.$timeout(() => {
      if (response.data && response.data.updatedRecord) {
        item.score = response.data.updatedRecord.score;
        item.score_last_updated_by = response.data.updatedRecord.score_last_updated_by;
        item.score_last_updated_date = response.data.updatedRecord.score_last_updated_date;
      } else {
        console.warn('No updatedRecord in response, updating manually');
        item.score = scoreData.score;
        item.score_last_updated_by = scoreData.score_last_updated_by;
        item.score_last_updated_date = new Date();
      }
      $scope.recalculateCategoryTotals();
    });
  })
  .catch(err => {
    console.error('Error updating score:', err);
    console.error('Error details:', err.data);
    vm.$timeout(() => {
      $scope.error = 'Failed to update score';
    });
  });
}; 

    $scope.showMessages = function (row) {
      console.log(row);
      $state.go('message-detail', {
        submissionId: row.submission_id,
        messageData: 'dashboard',
        data: row
      });
    };

    $scope.toggleStatusDropdown = function(event, item) {
      event.stopPropagation();

      item.showStatusDropdown = !item.showStatusDropdown;
    };

    $scope.updateSubmissionStatus = function(row, newStatus) {
      if ($scope.currentUser.role !== 'Administrator') {
        return;
      }
      row.originalStatus = row.status;
      row.originalUpdatedBy = row.status_last_updated_by;
      row.originalUpdatedDate = row.status_last_updated_date;
      row.status = newStatus;
      row.showStatusDropdown = false; 
      
      const updateData = {
          submission_id: row.submission_id,
          status: newStatus
      };
  
      fetch.updateItem('api/data/submissions/update-status', updateData)
          .then(response => {
              $timeout(() => {
                  row.status_last_updated_by = `${$scope.currentUser.firstname} ${$scope.currentUser.lastname}`;
                  row.status_last_updated_date = new Date();
                  $scope.successMessage = 'Status updated successfully';
              });
          })
          .catch(err => {
              console.error('Error updating status:', err);
              $timeout(() => {
                  row.status = row.originalStatus;
                  row.status_last_updated_by = row.originalUpdatedBy;
                  row.status_last_updated_date = row.originalUpdatedDate;
                  $scope.error = 'Failed to update status';
              });
          });
    };

    $scope.showStatusDropdown = function(item) {
      if ($scope.currentUser.role !== 'Administrator') {
        return;
      }
      if (item.hideTimeout) {
        $timeout.cancel(item.hideTimeout);
        item.hideTimeout = null;
      }
      
      item.showStatusDropdown = true;
    };
    
    $scope.hideStatusDropdown = function(item) {
      item.hideTimeout = $timeout(function() {
        item.showStatusDropdown = false;
        item.hideTimeout = null;
      }, 200);
    };
    

  $scope.getStationbyID = function (station) {
    console.log(station);
    if (station) {
      $scope.currentSelectedStationId = station;
      lookup.setCurrentStation(station);
    }

    vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
      

   
  }

  $scope.getStationAreaList = function (jurisdiction) {
    const staRecId = $stateParams.sta_recid;

    fetch.getAllItems(`api/data/stationareas/${jurisdiction}`)
      .then(response => {
        $scope.stationAreas = response.data;

        if (staRecId) {
          $scope.currentSelectedStationId = staRecId;
      } else if (lookup.getCurrentStation()) {
          $scope.currentSelectedStationId = lookup.getCurrentStation(); 
      } else {
        $scope.currentSelectedStationId = $scope.stationAreas[0].sta_recid;
      }

      lookup.setCurrentStation($scope.currentSelectedStationId);
      $scope.getStationbyID();
      })
      .catch(err => {
        console.log(err);
        if (err.status === 403) {
          $state.go('login');
        }
      });
  };
angular.element(document).on('click', function(event) {
  if (!event.target.closest('.status-pills')) {
    $scope.$apply(() => {
      if (!$scope.housingPolicySubmissions) return;
      $scope.housingPolicySubmissions.forEach(item => {
        item.showDropdown = false;
      });
    });
  }
});

}

  $onInit() {
    this.$scope.loading = true;

    this.$timeout(() => {
      this.userService.getCurrentUser()
        .then(response => {
          this.$scope.currentUser = response.data;
          this.userService.setCurrentUser(response.data);
          
          return this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list');
        })
        .then(response => {
          if (!Array.isArray(response.data)) {
            console.error('Unexpected response for jurisdiction-list:', response.data);
            this.$state.go('login');
            return;
          }
          this.$scope.jurisdictions = response.data;
          
          if (this.$scope.currentUser.role === 'Administrator') {
            const jurisdictionParam = this.$stateParams.jurisdiction;
            if (jurisdictionParam) {
              this.$scope.currentJurisdiction = jurisdictionParam;
            } else if (this.lookup.getJurisdiction()) {
              this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
            } else {
              this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
            }
          } else {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction() || 
              this.$scope.jurisdictions[0].jurisdiction;
          }
          this.lookup.setJurisdiction(this.$scope.currentJurisdiction);
          this.$scope.msg_selectedJurisdiction = this.$scope.currentJurisdiction;
          return this.fetch.getItem('api/data/stationareas', this.$scope.currentJurisdiction);
        })
        .then(response => {
  this.$scope.loading = false;
  this.$scope.stationAreas = response.data;

  const staRecIdParam = this.$stateParams.sta_recid;

  if (staRecIdParam) {
    this.$scope.currentSelectedStationId = staRecIdParam;
    this.lookup.setCurrentStation(staRecIdParam);
    return this.getStationAreaSubmissionSummary(staRecIdParam);
  }

  this.$scope.currentSelectedStationId = null;
  this.lookup.setCurrentStation(null);
  return this.getJurisdictionScoreSummary(this.$scope.currentJurisdiction);
})
        .then(() => {
          this.navService.getPage();
        })
        .catch(err => {
          console.error('Error in initialization:', err);
          this.$scope.loading = false;
          if (err.status === 403) {
            this.$state.go('login');
          }
        });
    }, 1000);
  }

  getJurisdictionList() {
    this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list')
      .then(response => {
        this.$scope.loading = false;
        if (!Array.isArray(response.data)) {
          console.error('Unexpected response for jurisdiction-list:', response.data);
          this.$state.go('login');
          return;
        }
        this.$scope.jurisdictions = response.data;

        // Check if user role is Administrator
        if (this.$scope.currentUser.role === 'Administrator') {
          console.log("admin");
          // Check for the jurisdiction parameter in the URL
          const jurisdictionParam = this.$stateParams.jurisdiction;
          console.log(this.$stateParams);
          if (jurisdictionParam) {
            this.$scope.currentJurisdiction = jurisdictionParam;
          } else if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            // If no parameter, default to the first jurisdiction
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        } else {
           if (this.lookup.getJurisdiction()) {
            this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
          } else {
            this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
          }
        }

        console.log(this.$scope.currentJurisdiction);
        this.lookup.setJurisdiction(this.$scope.currentJurisdiction);
        this.getStationAreas(this.$scope.currentJurisdiction);
      })
      .catch(err => {
        console.log(err);
      });
  }

  getStationAreas(jurisdiction, noStationArea) {
    this.$scope.loading = true;
    var stationId;
    this.$scope.currentJurisdiction = jurisdiction;
    this.lookup.setJurisdiction(jurisdiction);
    this.fetch.getItem(`api/data/stationareas`, jurisdiction)
      .then(response => {
        this.$scope.loading = false;
        this.$scope.stationAreas = response.data;
        console.log(this.$scope.stationAreas[0].sta_recid);
        stationId = this.$scope.stationAreas[0].sta_recid;
        if (noStationArea) {
          this.$scope.currentSelectedStationId = stationId;
        }
        else if (this.lookup.getCurrentStation()) {
          this.$scope.currentSelectedStationId = this.lookup.getCurrentStation();
        } else {
          this.$scope.currentSelectedStationId = stationId;
        }
        console.log(this.currentSelectedStationId);
        this.lookup.setCurrentStation(this.$scope.currentSelectedStationId);

        this.getStationAreaSubmissionSummary(this.$scope.currentSelectedStationId);

        this.$scope.msg_selectedStation = '3470ed7a-19cf-5dd4-b827-c52ba8c61bff';
      })
      .catch(err => {
        console.log(err);
      })
  }

    initializeSubmissions(submissions) {
    const vm = this;
    return submissions.map(function(item) {
      item.excludeFromScoring = vm.excludedPolicies.includes(item.submission_policy_name);
      if (item.score === null || item.score === undefined) {
        item.score = 0;
      }
      return item;
    });
  }
  getStationAreaSubmissionSummary(stationId) {
  console.log('Getting summary for station:', stationId);
  this.lookup.setCurrentStation(stationId);

  if (this.$scope.stationAreas.length > 0) {
    this.$scope.stationAreas.forEach(element => {
      element.active = element.sta_recid === stationId;
      if (element.active) {
        this.$scope.stationAreaTitle = element.station_name;
      }
    });

    return this.fetch.getItem(
      `api/data/policies/${this.$scope.currentJurisdiction}`, 
      stationId
    )
    .then(response => {
      console.log('Policy data:', response);
      this.$scope.submissionSummary = response.data;
      this.lookup.setSubmissionPolicies(response.data);
      console.log("submission summary: ",this.$scope.submissionSummary);

      this.$scope.densitySubmissions = this.initializeSubmissions(_.filter(response.data,
        { submission_policy_type: "Density" }));
      this.$scope.totalNewMessages_density = this.$scope.currentUser.organization === "MTC" ? _.sumBy(this.$scope.densitySubmissions, (o) => Number(o.mtc_newmessages_count)) : _.sumBy(this.$scope.densitySubmissions, (o) => Number(o.newmessages_count));
      this.$scope.totalScore_density = _.sumBy(this.$scope.densitySubmissions, (o) => Number(o.score));
      this.$scope.densitySubmitted = _.filter(this.$scope.densitySubmissions,
        { submitted: true });
      this.$scope.densityCompliant = _.filter(this.$scope.densitySubmissions,
        { status: 'Consistent' });

      this.$scope.housingPolicySubmissions = this.initializeSubmissions(_.filter(response.data,
        { submission_policy_type: "Housing Production Policy" }));
      this.$scope.housingPolicySubmissions = _.union(
        this.$scope.housingPolicySubmissions,
        _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }),
        _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }),
        _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" })
      );
      this.$scope.totalNewMessages_housing = this.$scope.currentUser.organization === "MTC" ? _.sumBy(this.$scope.housingPolicySubmissions, (o) => Number(o.mtc_newmessages_count)):_.sumBy(this.$scope.housingPolicySubmissions, (o) => Number(o.newmessages_count));
      this.$scope.totalScore_housing = _.sumBy(this.$scope.housingPolicySubmissions, (o) => Number(o.score));
      this.$scope.housingPolicySubmitted = _.filter(
        this.$scope.housingPolicySubmissions,
        { submitted: true }
      );
      this.$scope.housingPolicyCompliant = _.filter(
        this.$scope.housingPolicySubmissions,
        { status: 'Consistent' }
      );

      this.$scope.parkingSubmissions = this.initializeSubmissions(_.filter(response.data,
        { submission_policy_type: "Parking" }));
      this.$scope.totalNewMessages_parking = this.$scope.currentUser.organization === "MTC" ? _.sumBy(this.$scope.parkingSubmissions, (o) => Number(o.mtc_newmessages_count)): _.sumBy(this.$scope.parkingSubmissions, (o) => Number(o.newmessages_count));
      this.$scope.totalScore_parking = _.sumBy(this.$scope.parkingSubmissions, (o) => Number(o.score));
      this.$scope.parkingSubmitted = _.filter(this.$scope.parkingSubmissions,
        { submitted: true });
      this.$scope.parkingCompliant = _.filter(this.$scope.parkingSubmissions,
        { status: 'Consistent' });

      this.$scope.stationAccessSubmissions = this.initializeSubmissions(_.filter(response.data,
        { submission_policy_type: "Station Area Access" }));
      this.$scope.totalNewMessages_stationAccess = this.$scope.currentUser.organization === "MTC" ? _.sumBy(this.$scope.stationAccessSubmissions, (o) => Number(o.mtc_newmessages_count)):_.sumBy(this.$scope.stationAccessSubmissions, (o) => Number(o.newmessages_count));
      this.$scope.totalScore_stationAccess = _.sumBy(this.$scope.stationAccessSubmissions, (o) => Number(o.score));
      this.$scope.stationAccessSubmitted = _.filter(
        this.$scope.stationAccessSubmissions,
        { submitted: true }
      );
      this.$scope.stationAccessCompliant = _.filter(
        this.$scope.stationAccessSubmissions,
        { status: 'Consistent' }
      );
    });
    this.$scope.loading = false;
  } else {
    this.$scope.stationAreaTitle = '--';
    return Promise.resolve();
  }
  }

  getJurisdictionScoreSummary(jurisdiction) {
  this.$scope.loading = true;
  return this.fetch.getAllItems(`api/data/policies/${jurisdiction}`)
    .then(response => {
      const submissions = this.initializeSubmissions(response.data);
      const grouped = _.groupBy(submissions, 'sta_recid');

      this.$scope.stationCards = this.$scope.stationAreas.map(station => {
        const items = (grouped[station.sta_recid] || [])
          .filter(item => !item.excludeFromScoring);
        const score = _.sumBy(items, o => Number(o.score) || 0);
        const max_score = _.sumBy(items, o => Number(o.max_score) || 0) || 100;

        return { sta_recid: station.sta_recid, station_name: station.station_name, score, max_score };
      });

      const scored = this.$scope.stationCards.filter(c => c.max_score > 0);
      this.$scope.jurisdictionAverageScore = scored.length
        ? Math.round(_.sumBy(scored, 'score') / scored.length)
        : 0;
      this.$scope.jurisdictionMaxScore = scored.length
        ? Math.round(_.meanBy(scored, 'max_score'))
        : 100;
      // this.$scope.jurisdictionComplianceIcon =
      //   this.getComplianceIcon(this.$scope.jurisdictionAverageScore, this.$scope.jurisdictionMaxScore);

      this.$scope.loading = false;
    })
    .catch(err => {
      console.error('Error loading jurisdiction score summary:', err);
      this.$scope.loading = false;
    });
}

getComplianceIcon(score, maxScore) {
  const pct = maxScore ? (score / maxScore) * 100 : 0;
  if (pct >= 80) return { class: 'fa-solid fa-circle-check', color: '#2e7d32' };
  if (pct >= 50) return { class: 'fa-solid fa-triangle-exclamation', color: '#f2994a' };
  return { class: 'fa-solid fa-triangle-exclamation', color: '#d32f2f' };
}

selectStationCard(staRecId) {
  this.$scope.currentSelectedStationId = staRecId;
  this.lookup.setCurrentStation(staRecId);
  this.$state.go('dashboard', { sta_recid: staRecId }, { location: 'replace', notify: false });
  this.getStationAreaSubmissionSummary(staRecId);
}

clearStationSelection() {
  this.$scope.currentSelectedStationId = null;
  this.lookup.setCurrentStation(null);
  this.$state.go('dashboard', { sta_recid: null }, { location: 'replace', notify: false });
  this.getJurisdictionScoreSummary(this.$scope.currentJurisdiction);
}

onJurisdictionChange(jurisdiction) {
  this.$scope.loading = true;
  this.$scope.currentJurisdiction = jurisdiction;
  this.lookup.setJurisdiction(jurisdiction);
  this.$scope.currentSelectedStationId = null;
  this.lookup.setCurrentStation(null);

  this.fetch.getItem('api/data/stationareas', jurisdiction)
    .then(response => {
      this.$scope.stationAreas = response.data;
      return this.getJurisdictionScoreSummary(jurisdiction);
    })
    .catch(err => console.error(err));
}



  /**
   * Sets clicked link subItem attribute active to true in order to add "active" class to link
   * @param {*} subItem 
   */
  setActive(subItem, item) {
    var subItemTitle = subItem.title;
    item.subItem1.forEach(element => {
      if (element.title === subItemTitle) {
        element.active = true;
      } else {
        element.active = false;
      }
    });
  }
}

export default angular.module('appApp.dashboard', [uiRouter])
  .config(routes)
  .component('dashboard', {
    template: require('./dashboard.html'),
    controller: DashboardComponent,
    controllerAs: 'dashboardCtrl'
  })
  .name;


// WEBPACK FOOTER //
// ./client/app/account/dashboard/dashboard.component.js